import "bootstrap";
require('./bootstrap');

$(function () {
    let $body = $("body");
    const navBarHeight = 100;

    $body.on('click','#navbar-menu-button',function(){
        $body.toggleClass("body-no-scroll");
        $(this).toggleClass("is-active");
        $("#navbarSupportedContent").toggleClass("show");
    });


    $("a[href^='#']").click(function (e) {
        e.preventDefault();
        var position = $($(this).attr("href")).offset().top;
        $("body, html").animate({
            scrollTop: position - navBarHeight
        } /* speed */);
        if($body.width() <= 992 &&  $("#navbarSupportedContent").hasClass("show")){
            $("#navbar-menu-button").trigger("click")
        }
    });

    $body.on("click",".spec-shower",function(){
        $(this).closest(".class__title").addClass("show");
        $(this).closest(".class__container").find(".interact-inner").addClass("show")
    });

    $body.on("click",".button__close",function(){
        $(this).closest(".class__container").find(".class__title").removeClass("show");
        $(this).closest(".interact-inner").removeClass("show")
    });
});
